import { Breadcrumb, Dropdown } from "react-bootstrap";
import useProjectBulletinLogic from "./project-bulletin-logic";
import "./project-bulletin.scss";
import { formatToFullDate, toCapitalCase } from "../../core/util/util-functions";
import { RiDashboardLine } from "react-icons/ri";
import { CiMenuKebab } from "react-icons/ci";
import { LoaderScreenFactory } from "@common/loader";
import { Link, useNavigate } from "react-router-dom";
import { StatusModalFactory } from "@common/modal";
import SaveEditDashboard from "../../shared/modal/edit-dashboard/edit-dashboard-modal";
import { useState } from "react";
import { Dashboard } from "../../core/interface/dashboard";
import { IoIosStar, IoIosStarOutline } from "react-icons/io";
import { getCurrentSelection } from "../../core/services/user.service";
import { AiOutlineEdit } from "react-icons/ai";

export default function ProjectBulletinPage() {

	const navigate = useNavigate();
	const { stateObject, dashboardList, projectDashboards, changeAndReload, handleCloseModal, duplicateDashboard, deleteDashboard, showSaveModal, setShowSaveModal, addFavouriteDashboard } = useProjectBulletinLogic();
	const [currentDashboard, setCurrentDashboard] = useState<Dashboard>(projectDashboards[0]);

	return (
		<div className="project-bulletin-wrapper">
			{
				stateObject.callInProgress ? <LoaderScreenFactory /> :
					<>
						<div className="left-section">
							{
								dashboardList && dashboardList.map((project, index) => {
									return (
										<>
											<div className="list-title" key={'listTitle-' + index} onClick={() => changeAndReload(project.projectId + '', project.projectName)}>{project.projectName.toUpperCase()}</div>
											{
												project.dashboard && project.dashboard.map((dashboard, index1) => {
													return (
														<div className="list-item" key={'dashboard-item-' + index1} onClick={() => navigate(`/bulletin/${dashboard.dashboardId}`)}>
															<RiDashboardLine />{dashboard.dashboardTitle}
														</div>
													)
												})
											}
										</>
									)
								})
							}
						</div>
						<div className="right-section">
							{
								projectDashboards && projectDashboards.length > 0 ?
									<>
										<div className="row top-bar">
											<div className="col-sm-12 col-md-6">
												<Breadcrumb>
													<Breadcrumb.Item active>Home</Breadcrumb.Item>
													<Breadcrumb.Item active>{toCapitalCase(getCurrentSelection().name)}</Breadcrumb.Item>
													<Breadcrumb.Item active>Bulletin</Breadcrumb.Item>
												</Breadcrumb>
											</div>
											<div className="col-sm-12 col-md-6 text-end">
												<Link to="/bulletin/0" className="btn btn-sm" >
													Add bulletin
												</Link>
											</div>

										</div>
										<div className="row">
											<div className="dashboard-list row">
												{
													projectDashboards && projectDashboards.map((dashboard, index) => {
														return (
															<div className="col-sm-12 col-md-4 mb-4" key={'dashboard-card-' + index}>
																<div className="card dashboard-card">
																	<div className="card-body">
																		<div className="card-header d-flex">
																			<div className="title" onClick={() => navigate(`/bulletin/${dashboard.dashboardId}`)}>{dashboard.dashboardTitle}</div>
																			<div className=" d-flex">
																				<div className="options-menu" onClick={() => { addFavouriteDashboard(dashboard.dashboardId + '') }}>
																					{
																						dashboard.favourite ? <IoIosStar className="text-warning" /> : <IoIosStarOutline />
																					}
																				</div>
																				<div className="options-menu" onClick={() => { setCurrentDashboard(dashboard); setShowSaveModal(true); }}><AiOutlineEdit /></div>
																				<Dropdown className="options-menu">
																					<Dropdown.Toggle as="div" className="bg-transparent"><CiMenuKebab /></Dropdown.Toggle>
																					<Dropdown.Menu className="options-dropdown-menu">
																						<Dropdown.Item onClick={() => duplicateDashboard(dashboard.dashboardId + '')}>Duplicate</Dropdown.Item>
																						<Dropdown.Divider />
																						<Dropdown.Item onClick={() => deleteDashboard(dashboard.dashboardId + '')}>Delete</Dropdown.Item>
																					</Dropdown.Menu>
																				</Dropdown>
																			</div>

																		</div>
																		<div className="description">{dashboard.dashboardDescription}</div>
																		<div className="row">
																			<table className="meta-table">
																				<tbody>
																					<tr>
																						<td><strong>Created by:</strong> {dashboard.dashboardCreatedBy}</td>
																						<td><strong>Updated by:</strong> {dashboard.lastUpdatedBy}</td>
																					</tr>
																					<tr>
																						<td><strong>Created:</strong> {formatToFullDate(dashboard.dashboardCreatedDate)}</td>
																						<td><strong>Updated:</strong> {formatToFullDate(dashboard.dashboardUpdatedDate)}</td>
																					</tr>
																				</tbody>
																			</table>
																		</div>
																	</div>
																</div>
															</div>
														)
													})
												}
											</div>
										</div>
									</> : <div className="content-area">
										<div className="dotted-box">
											There are no dashboard defined for this project.
											<br />
											Click on top right button to add one.
										</div>
									</div>
							}

						</div>
					</>
			}
			<SaveEditDashboard showModal={showSaveModal} handleCloseModal={handleCloseModal} dashboard={currentDashboard} isEdit={true} />
			<StatusModalFactory showModal={stateObject.showErrorModal} handleCloseModal={handleCloseModal} modalContent={{ title: 'Attention!!!', message: stateObject.statusMessage }} />
		</div>
	)
}